var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-progress-bar.ts
import { html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { ChemistryLitElement } from "../../chemistry-lit-element.js";
import { ComponentSizeController } from "../../controllers/component-size-controller.js";
import { acss } from "../../directives/acss.js";
var XProgressBar = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.value = 0;
    this.transitionDuration = 0.2;
    this.size = new ComponentSizeController(this, { debounceTime: 200 });
  }
  styles() {
    return [
      {
        ":host": {
          display: "block",
          height: this.spacing.sm,
          transition: `height .5s ease, background-color .5s ease`,
          position: "relative",
          backgroundColor: this.colors.neutral.shade(200)
        },
        "#progress": {
          height: "100%",
          width: "100px",
          background: this.colors.accent,
          transformOrigin: "left"
        },
        ...Object.keys(this.colors.tone).reduce(
          (acc, toneKey) => ({
            ...acc,
            [`:host([tone=${toneKey}]) #progress`]: { background: this.colors.tone[toneKey] }
          }),
          {}
        )
      }
    ];
  }
  render() {
    return html`
      <div
        id="progress"
        ${acss({
      transition: `transform ${this.transitionDuration}s linear`,
      transform: `scaleX(${(Math.min((this.value || 0) * (this.size.width ?? 0), this.size.width ?? 0) / 100).toFixed(2)})`
    })}
      ></div>
    `;
  }
};
__decorateClass([
  state()
], XProgressBar.prototype, "value", 2);
__decorateClass([
  state()
], XProgressBar.prototype, "transitionDuration", 2);
__decorateClass([
  state()
], XProgressBar.prototype, "size", 2);
XProgressBar = __decorateClass([
  customElement("x-progress-bar")
], XProgressBar);
export {
  XProgressBar
};
